var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainerre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M8.19199 15L8.68366 15.4916L10.0003 16.8083L11.3253 15.4833L11.8087 15H15.8337V3.33331H4.16699V15H8.19199ZM10.0003 4.16665C11.3753 4.16665 12.5003 5.29165 12.5003 6.66665C12.5003 8.04165 11.3753 9.16665 10.0003 9.16665C8.62533 9.16665 7.50033 8.04165 7.50033 6.66665C7.50033 5.29165 8.62533 4.16665 10.0003 4.16665ZM5.00033 12.9833C5.00033 10.9 8.30866 9.99998 10.0003 9.99998C11.692 9.99998 15.0003 10.9 15.0003 12.9833V14.1666H5.00033V12.9833Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16.6667L10 19.1667L12.5 16.6667H15.8333C16.75 16.6667 17.5 15.9167 17.5 15V3.33335C17.5 2.41669 16.75 1.66669 15.8333 1.66669H4.16667C3.24167 1.66669 2.5 2.41669 2.5 3.33335V15C2.5 15.9167 3.24167 16.6667 4.16667 16.6667H7.5ZM4.16667 3.33335H15.8333V15H11.8083L11.3167 15.4917L10 16.8084L8.675 15.4834L8.19167 15H4.16667V3.33335ZM10 9.16669C11.375 9.16669 12.5 8.04169 12.5 6.66669C12.5 5.29169 11.375 4.16669 10 4.16669C8.625 4.16669 7.5 5.29169 7.5 6.66669C7.5 8.04169 8.625 9.16669 10 9.16669ZM10 5.83335C10.4583 5.83335 10.8333 6.20835 10.8333 6.66669C10.8333 7.12502 10.4583 7.50002 10 7.50002C9.54167 7.50002 9.16667 7.12502 9.16667 6.66669C9.16667 6.20835 9.54167 5.83335 10 5.83335ZM15 12.9834C15 10.9 11.6917 10 10 10C8.30833 10 5 10.9 5 12.9834V14.1667H15V12.9834ZM7.06667 12.5C7.68333 12.075 8.925 11.6667 10 11.6667C11.075 11.6667 12.3167 12.075 12.9333 12.5H7.06667Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainerre);
export default __webpack_public_path__ + "static/media/trainerre.a303c96d5d6524a87df3cf7645927083.svg";
export { ForwardRef as ReactComponent };